import { useEffect, useState } from "react";
import { useCurrencyContext } from "../context/Currency/CurrencyContext";
import { Currency } from "../types/Currency/Currency";

export interface PriceProps {
  price: number;
  currencyCode: string;
}

const Price = ({ price, currencyCode }: PriceProps) => {
  const { currencies } = useCurrencyContext();
  const [currency, setCurrency] = useState<Currency>();

  useEffect(() => {
    if (currencies) {
      const currency = currencies.find((c) => c.code === currencyCode);
      setCurrency(currency);
    }
  }, [currencies, currencyCode]);

  return (
    <>
      {currency?.symbol}
      {price
        .toFixed(currency?.isZeroDecimal ? 0 : 2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
    </>
  );
};

export default Price;
